import Swiper from "swiper/bundle";

const brand = {
  init() {
    brand.slider();

    if (window.innerWidth > 900) {
      brand.side();
    }
  },

  side() {
    const anchorEl = $(".brand-page .anchor");
    const header = $(".header");
    const aside = $(".brand-page .aside");

    $(window).on("scroll", (e) => {
      const headerHeight = header.innerHeight();
      const scrolled = $(e.currentTarget).scrollTop();
      const anchorOffsetTop = anchorEl.offset().top;
      const asideHeight = aside.innerHeight();
      const maxScrollPosition = anchorEl.innerHeight() - asideHeight + anchorOffsetTop - 70;

      if (scrolled >= headerHeight && scrolled <= maxScrollPosition) {
        const topPosition = scrolled - anchorOffsetTop + headerHeight;
        aside.css({
          "top": topPosition + 50,
          "position": "absolute"
        });
      } else if (scrolled < headerHeight) {
        aside.css("position", "static");
      } else if (scrolled > maxScrollPosition) {
        aside.css({
          "top": maxScrollPosition - anchorOffsetTop + headerHeight + 50,
          "position": "absolute"
        });
      }
    });
  },

  slider() {
    const sliderEl = $(".brand-main-slider-wrapper");

    const slider = new Swiper(sliderEl.find(".brand-slider")[0], {
      init: sliderEl.find(".swiper-slide").length > 1,
      slidesPerView: 1,
      loop: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },

      navigation: {
        prevEl: sliderEl.find(".swiper-button-prev")[0],
        nextEl: sliderEl.find(".swiper-button-next")[0],
      },

      pagination: {
        el: sliderEl.find(".swiper-pagination"),
        type: "bullets",
      },
    });
  },
};

export default brand;
